import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { Divider, List, ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Types as UserTypes } from '../../sagas/users';
import './index.scss';

const ListItems = ({ closeSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [clickedItem, setClickedItem] = useState(null);

  const handleNavigation = (path) => {
    setClickedItem(path);
    setTimeout(() => {
      navigate(path);
      if (closeSidebar) closeSidebar();
    }, 300);
  };

  const isActive = (path) => location.pathname === path;

  const requestLogout = () => {
    dispatch({
      type: UserTypes.logout,
      payload: {
        onSuccess: () => {
          navigate('/login');
        },
        onError: (error) => {
          console.error(error);
        }
      }
    });
  };

  return (
    <List className="listItems">
      <ListItem
        button
        onClick={() => handleNavigation('/select-option')}
        className={`listItem ${isActive('/select-option') ? 'active' : ''} ${clickedItem === '/select-option' ? 'clicked' : ''}`}
      >
        <Tooltip title="Início" arrow>
          <ListItemIcon className="listItemIcon">
            <ListAltIcon />
          </ListItemIcon>
        </Tooltip>
        <ListItemText primary="Início" className="listItemText" />
      </ListItem>

      <ListItem
        button
        onClick={() => handleNavigation('/my-training')}
        className={`listItem ${isActive('/my-training') ? 'active' : ''} ${clickedItem === '/my-training' ? 'clicked' : ''}`}
      >
        <Tooltip title="Meus treinos" arrow>
          <ListItemIcon className="listItemIcon">
            <FitnessCenterIcon />
          </ListItemIcon>
        </Tooltip>
        <ListItemText primary="Meus Treinos" className="listItemText" />
      </ListItem>

      <ListItem
        button
        onClick={() => handleNavigation('/weekly-schedule')}
        className={`listItem ${isActive('/weekly-schedule') ? 'active' : ''} ${clickedItem === '/weekly-schedule' ? 'clicked' : ''}`}
      >
        <Tooltip title="Programação Semanal" arrow>
          <ListItemIcon className="listItemIcon">
            <CalendarMonthIcon />
          </ListItemIcon>
        </Tooltip>
        <ListItemText primary="Programação Semanal" className="listItemText" />
      </ListItem>

      <ListItem
        button
        onClick={() => handleNavigation('/schedule-modality')}
        className={`listItem ${isActive('/schedule-modality') ? 'active' : ''} ${clickedItem === '/schedule-modality' ? 'clicked' : ''}`}
      >
        <Tooltip title="Agendar uma modalidade" arrow>
          <ListItemIcon className="listItemIcon">
            <CalendarTodayIcon />
          </ListItemIcon>
        </Tooltip>
        <ListItemText primary="Agendar" className="listItemText" />
      </ListItem>

      <ListItem
        button
        onClick={() => handleNavigation('/my-schedule')}
        className={`listItem ${isActive('/my-schedule') ? 'active' : ''} ${clickedItem === '/my-schedule' ? 'clicked' : ''}`}
      >
        <Tooltip title="Meus agendamentos" arrow>
          <ListItemIcon className="listItemIcon">
            <EventNoteIcon />
          </ListItemIcon>
        </Tooltip>
        <ListItemText primary="Meus Agendamentos" className="listItemText" />
      </ListItem>

      <ListItem
        button
        onClick={() => handleNavigation('/profile')}
        className={`listItem ${isActive('/profile') ? 'active' : ''} ${clickedItem === '/profile' ? 'clicked' : ''}`}
      >
        <Tooltip title="Meu perfil" arrow>
          <ListItemIcon className="listItemIcon">
            <AccountCircleIcon />
          </ListItemIcon>
        </Tooltip>
        <ListItemText primary="Meu Perfil" className="listItemText" />
      </ListItem>

      <Divider sx={{ margin: '8px 0' }} />

      <ListItem
        button
        onClick={() => requestLogout()}
        className={`listItem ${isActive('/login') ? 'active' : ''} ${clickedItem === '/login' ? 'clicked' : ''}`}
      >
        <Tooltip title="Sair" arrow>
          <ListItemIcon className="listItemIcon">
            <ExitToAppIcon />
          </ListItemIcon>
        </Tooltip>
        <ListItemText primary="Sair" className="listItemText" />
      </ListItem>
    </List>
  );
};

export default ListItems;
